// extracted by mini-css-extract-plugin
export default {"card":"AudioGenerator_card__hBj7B","card-group":"AudioGenerator_card-group__8K222","container":"AudioGenerator_container__asLwv","horizontal":"AudioGenerator_horizontal__h3W2r"};